export type EliteWrappedFrame = {
  line1?: string
  line2?: string
  line3?: string
  line4?: string
  line5?: string
  line6?: string
}

export type EliteWrappedResponse = {
  frameData: EliteWrappedFrame[]
  eliteRenewalStatus: 'EXPIRED_ELITE' | 'RENEWED_ELITE' | 'PENDING_RENEWAL_ELITE'
}

export const ELITE_RENEW_TEXT_RUN = 'Elite_Renew' as const

export const ELITE_RENEW_CTA_RENEW = 'Renew your PowerUp Elite membership instantly'
export const ELITE_RENEW_CTA_CONTINUE = 'Continue to PowerUp Elite'

export function getEliteRenewCtaText(
  eliteRenewalStatus: EliteWrappedResponse['eliteRenewalStatus'] | undefined
): string {
  if (eliteRenewalStatus === 'RENEWED_ELITE') {
    return ELITE_RENEW_CTA_CONTINUE
  }
  return ELITE_RENEW_CTA_RENEW
}
